export enum PRODUCT_CLONE_ERROR {
  PRODUCT_LABEL_NOT_FOUND = 'PRODUCT_LABEL_NOT_FOUND',
}

export const PRODUCT_CLONE_ERRORS = {
  [PRODUCT_CLONE_ERROR.PRODUCT_LABEL_NOT_FOUND]: {
    description: 'errors:PRODUCT_LABEL_NOT_FOUND',
  },
};
